import type { JointStageData, NodeStru } from "../../common";
import { globalEvents, GlobalEvents } from "../../../utils/globalevents";
import { wasmModule } from "../wasm/wasmModule";
import { treatmentPlan } from "../treatmentplan";
import { ESetupType } from "../../typesofinterface";
import { refinementModule } from "../refinement";

// import { disPatchPanelDataCallback } from '../toothmanager/toothmovement';

class StagingManager {
  stageupIndex = 0;
  stagelowIndex = 0;
  stageUpnNumber = 0;
  stageLowNumber = 0;
  showRefinementHistoryRangeType = ""; //for ui controll
  wasmStageData: JointStageData = {
    jointLowerKeypoints: [],
    jointUpKeypoints: [],
    hasLowerLastData: true,
    hasUpLastData: true,
    keypointsIndex: 0,
    curNodeIndex: 0,
    curLowerNodeIndex: 0,
    curUpNodeIndex: 0,
    refinementHistoryUpNumber: 0,
    historyStepUpCount: 0,
    refinementHistoryDownNumber: 0,
    historyStepDownCount: 0,
  };
  setStageCallback?: (stageData: any) => void;
  setupTypeAndStage?: (type: ESetupType, ndoeIndex: number) => void;
  GetNodeTypes = nodeType => {
    const eNodeTypes: number[] = [];
    for (let index = 0; index < 16; index++) {
      const val = 1 << index;
      if (nodeType & val) {
        eNodeTypes.push(index);
      }
    }
    return eNodeTypes;
  };
  isStageIndexToothMoveTypes = (arch: number) => {
    let nodeType: number[] = [];
    if (arch === 0 && this.wasmStageData.jointUpKeypoints.length > 0)
      nodeType =
        this.wasmStageData.jointUpKeypoints[this.wasmStageData.curUpNodeIndex]
          .nodeType;
    else if (arch === 1 && this.wasmStageData.jointLowerKeypoints.length > 0)
      nodeType =
        this.wasmStageData.jointLowerKeypoints[
          this.wasmStageData.curLowerNodeIndex
        ].nodeType;
    for (let i = 0; i < nodeType.length; i++) {
      if (nodeType[i] === 0) return true;
    }
    return false;
  };
  updateStagesCallback(callback: (arch: number, index: number) => void) {
    (window as any).updateStagesCallback = callback;
    wasmModule.module
      .getScanPreviewWin()
      .SetUpdateSliderCB("updateStagesCallback");
  }

  getNodeTypesByStep = (nodes, stepIndex) => {
    let nodeTypes = -1;
    for (let i = 0; i < nodes.size(); i++) {
      const node = nodes.get(i);
      if (node.stepindex === stepIndex) {
        nodeTypes = node.GetNodeType();
      }
    }
    return nodeTypes;
  };

  // setupdateStagesCallback() {
  //   this.updateStagesCallback((arch: number, index: number) => {
  //     this.updateStageCallback(arch, index);
  //     report.update();
  //     // disPatchPanelDataCallback();
  //   });
  // }
  /**
   * 刷新StageData
   * @param arch
   * @param nodes
   */
  setStageData = async (arch, nodes) => {
    const nodesSize = nodes.size();
    let lastStepNumber = 0;
    if (nodesSize > 0) {
      const lastNode = nodes.get(nodesSize - 1);
      lastStepNumber = lastNode.stepindex;
      // console.info("=====lastStepNumber:" + lastStepNumber)
    }
    if (arch === 0) {
      this.stageUpnNumber = lastStepNumber;
      this.wasmStageData.jointUpKeypoints = [];
      //  this.wasmStageData.curUpNodeIndex = this.stageUpnNumber;
    } else if (arch === 1) {
      this.stageLowNumber = lastStepNumber;
      this.wasmStageData.jointLowerKeypoints = [];
      // this.wasmStageData.curLowerNodeIndex = this.stageLowNumber;
    }

    const refinementHistoryNumber =
      refinementModule.getNumberOfRefinement(arch);
    let historyStepNumber = 0;
    if (refinementHistoryNumber > 0) {
      historyStepNumber = refinementModule.getHistoryStageNumber(arch);
    }
    const stageNameArray = refinementModule.getRefinementInfo(arch);
    if (arch === 0) {
      console.info("===== up arch stageNameArray: ", stageNameArray);
      if (this.showRefinementHistoryRangeType !== "") {
        this.stageUpnNumber = stageNameArray.length - 1;
      }
      this.wasmStageData.refinementHistoryUpNumber = refinementHistoryNumber;
      this.wasmStageData.historyStepUpCount = historyStepNumber;
    } else if (arch === 1) {
      console.info("===== down arch stageNameArray: ", stageNameArray);
      if (this.showRefinementHistoryRangeType !== "") {
        this.stageLowNumber = stageNameArray.length - 1;
      }
      this.wasmStageData.refinementHistoryDownNumber = refinementHistoryNumber;
      this.wasmStageData.historyStepDownCount = historyStepNumber;
    }

    for (let i = 0; i <= lastStepNumber && lastStepNumber > 0; i++) {
      const nodeStru: NodeStru = {
        nodeType: [],
        stepindex: -1,
        posPace: 0.25,
        degreePace: 2.5,
        name: "",
      };
      nodeStru.stepindex = i;

      //show nornal
      if (this.showRefinementHistoryRangeType === "") {
        if (historyStepNumber === 0) {
          nodeStru.name = i + "";
        } else {
          if (i === 0) {
            nodeStru.name = "R" + refinementHistoryNumber;
          } else {
            nodeStru.name = i + historyStepNumber - 1 + "";
          }
        }
      } else {
        //show history
        nodeStru.name = stageNameArray[i];
      }

      for (let j = 0; j < nodes.size(); j++) {
        const node = nodes.get(j);
        if (node.stepindex === i) {
          // console.log('setnode index::',i)
          nodeStru.degreePace = node.degreePace;
          nodeStru.posPace = node.posPace;
          nodeStru.nodeType = this.GetNodeTypes(node.GetNodeType());
        }
      }
      if (arch === 0) this.wasmStageData.jointUpKeypoints.push(nodeStru);
      else if (arch === 1)
        this.wasmStageData.jointLowerKeypoints.push(nodeStru);
    }
  };
  patientstxNumber = () => {
    let txNumber = 0;
    if (
      this.wasmStageData.jointUpKeypoints.length !== 0 ||
      this.wasmStageData.jointLowerKeypoints.length !== 0
    ) {
      txNumber++;
    }
    if (wasmModule.stagingcontoler.Tx2Exist()) {
      txNumber++;
    }
    return txNumber;
  };
  /**
   *  stagedata to UI
   */
  patientsSetStageDataTx = async () => {
    this.wasmStageData.curUpNodeIndex =
      this.wasmStageData.jointUpKeypoints.length - 1;
    this.wasmStageData.curLowerNodeIndex =
      this.wasmStageData.jointLowerKeypoints.length - 1;
    if (
      this.wasmStageData.jointUpKeypoints.length >=
      this.wasmStageData.jointLowerKeypoints.length
    )
      this.wasmStageData.keypointsIndex =
        this.wasmStageData.jointUpKeypoints.length - 1;
    else
      this.wasmStageData.keypointsIndex =
        this.wasmStageData.jointLowerKeypoints.length - 1;

    if (
      this.wasmStageData.curUpNodeIndex >= this.wasmStageData.curLowerNodeIndex
    )
      this.wasmStageData.curNodeIndex = this.wasmStageData.curUpNodeIndex;
    else this.wasmStageData.curNodeIndex = this.wasmStageData.curLowerNodeIndex;
    const stageData = JSON.parse(JSON.stringify(this.wasmStageData));
    if (this.setStageCallback) this.setStageCallback(stageData);
  };
  /**
   * stagedata to UI
   * @param arch
   * @param index
   */
  patientsSetStageData = async (arch, index) => {
    if (arch === 0) this.wasmStageData.curUpNodeIndex = index;
    else if (arch === 1) this.wasmStageData.curLowerNodeIndex = index;
    if (
      this.wasmStageData.jointUpKeypoints.length >=
      this.wasmStageData.jointLowerKeypoints.length
    )
      this.wasmStageData.keypointsIndex =
        this.wasmStageData.jointUpKeypoints.length - 1;
    else
      this.wasmStageData.keypointsIndex =
        this.wasmStageData.jointLowerKeypoints.length - 1;

    if (
      this.wasmStageData.curUpNodeIndex >= this.wasmStageData.curLowerNodeIndex
    )
      this.wasmStageData.curNodeIndex = this.wasmStageData.curUpNodeIndex;
    else this.wasmStageData.curNodeIndex = this.wasmStageData.curLowerNodeIndex;
    const stageData = JSON.parse(JSON.stringify(this.wasmStageData));
    if (this.setStageCallback) this.setStageCallback(stageData);
  };

  deleteKeyNode(archType: boolean, stepIndex: number) {
    let type = 1;
    if (archType) type = 0;
    wasmModule.stagingcontoler.DeleteNode(type, stepIndex);
  }
  addNormalNode(archType: boolean, stepIndex: number, lastNode: boolean) {
    let type = 1;
    if (archType) type = 0;
    wasmModule.stagingcontoler.AddNormalNode(type, stepIndex, lastNode);
  }

  VelocityUpAndDownArchEqual() {
    if (!wasmModule.isInit) return;

    wasmModule.stagingcontoler.VelocityUpAndDownArchEqual();

    this.updateStages();
  }
  VelocityUpArchPlus() {
    if (!wasmModule.isInit) return;
    wasmModule.stagingcontoler.VelocityUpArchPlus();
    this.updateStages();
  }
  VelocityUpArchMinus() {
    if (!wasmModule.isInit) return;

    wasmModule.stagingcontoler.VelocityUpArchMinus();

    this.updateStages();
  }
  VelocityUpArchRestore() {
    if (!wasmModule.isInit) return;

    wasmModule.stagingcontoler.VelocityUpArchRestore();

    this.updateStages();
  }
  VelocityDownArchPlus() {
    if (!wasmModule.isInit) return;

    wasmModule.stagingcontoler.VelocityDownArchPlus();

    this.updateStages();
  }
  VelocityDownArchMinus() {
    if (!wasmModule.isInit) return;

    wasmModule.stagingcontoler.VelocityDownArchMinus();

    this.updateStages();
  }
  VelocityDownArchRestore() {
    if (!wasmModule.isInit) return;

    wasmModule.stagingcontoler.VelocityDownArchRestore();

    this.updateStages();
  }
  initFinishedupdateStageCallback() {
    //open refinment module
    refinementModule.openRefinementModule(true);

    this.stageupIndex = 0;
    this.stagelowIndex = 0;
    this.stageUpnNumber = 0;
    this.stageLowNumber = 0;
    this.updateStages();
    this.patientsSetStageDataTx();
    // this.patientsSetStageData(0, wasmModule.stagingcontoler.GetCurrentStageIndexWithActor(0));
    // this.patientsSetStageData(1, wasmModule.stagingcontoler.GetCurrentStageIndexWithActor(1));
  }
  updateStageCallback(arch: number, index: number) {
    // console.log('>>>>>updateStageCallback',arch,index)
    this.updateStages();
    this.patientsSetStageData(arch, index);
  }
  updateStages() {
    const curTxNumber = treatmentPlan.currentTxIndex;
    console.info("=====currentTxIndex:" + curTxNumber);
    const upArchRefinementHistoryNumber =
      refinementModule.getNumberOfRefinement(0);
    const downArchRefinementHistoryNumber =
      refinementModule.getNumberOfRefinement(1);
    console.info(
      "=====upArchRefinementHistoryNumber:",
      upArchRefinementHistoryNumber
    );
    console.info(
      "=====downArchRefinementHistoryNumber:",
      downArchRefinementHistoryNumber
    );

    let upNodes, lowerNodes;
    //do not show history
    if (this.showRefinementHistoryRangeType === "") {
      upNodes = wasmModule.mouthModel.GetNodes(0, curTxNumber);
      lowerNodes = wasmModule.mouthModel.GetNodes(1, curTxNumber);
    } else {
      //show history
      upNodes = refinementModule.getCurNodes(0);
      lowerNodes = refinementModule.getCurNodes(1);
    }

    for (let j = 0; j < upNodes.size(); j++) {
      const node = upNodes.get(j);
      console.info("=====upNodes:" + node.stepindex + "," + node.GetNodeType());
    }

    for (let j = 0; j < lowerNodes.size(); j++) {
      const node = lowerNodes.get(j);
      console.info(
        "=====lowerNodes:" + node.stepindex + "," + node.GetNodeType()
      );
    }

    this.setStageData(0, upNodes);
    this.setStageData(1, lowerNodes);

    upNodes = null;
    lowerNodes = null;
  }
  /**
   * 设置wasm-stage当前index
   */
  setStageStep = (up, down) => {
    if (up != undefined) this.wasmStageData.curUpNodeIndex = up;
    if (down != undefined) this.wasmStageData.curLowerNodeIndex = down;
    if (this.showRefinementHistoryRangeType === "") {
      if (this.stageupIndex !== up && up >= down) this.promisesetStage(up);
      else if (this.stagelowIndex !== down) this.promisesetStage(down);
    } else {
      if (this.stageupIndex !== up) {
        console.info("=====changeDisplayStageValue: ", up, "arch type: ", 0);
        refinementModule.changeDisplayStageValue(up, 0);
      }
      if (this.stagelowIndex !== down) {
        console.info("=====changeDisplayStageValue: ", down, "arch type: ", 1);
        refinementModule.changeDisplayStageValue(down, 1);
      }
    }

    // disPatchPanelDataCallback();
  };

  async setStageStepAwait(up, down) {
    if (up != undefined) this.wasmStageData.curUpNodeIndex = up;
    if (down != undefined) this.wasmStageData.curLowerNodeIndex = down;
    if (this.showRefinementHistoryRangeType === "") {
      if (this.stageupIndex !== up && up >= down)
        await this.promisesetStage(up);
      if (this.stagelowIndex !== down) await this.promisesetStage(down);
    } else {
      if (this.stageupIndex !== up) {
        console.info("=====changeDisplayStageValue: ", up, "arch type: ", 0);
        refinementModule.changeDisplayStageValue(up, 0);
      }
      if (this.stagelowIndex !== down) {
        console.info("=====changeDisplayStageValue: ", down, "arch type: ", 1);
        refinementModule.changeDisplayStageValue(down, 1);
      }
    }

    // disPatchPanelDataCallback();
  }
  promisesetStage = stageIndex => {
    this.stageupIndex = stageIndex;
    this.stagelowIndex = stageIndex;
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        let stageup = this.stageupIndex;
        let stagelow = this.stagelowIndex;
        if (stageup === null) stageup = 0;
        if (stagelow === null) stagelow = 0;
        if (stageup > this.stageUpnNumber) {
          stageup = this.stageUpnNumber;
          this.stageupIndex = this.stageUpnNumber;
        }
        if (stagelow > this.stageLowNumber) {
          stagelow = this.stageLowNumber;
          this.stagelowIndex = this.stageLowNumber;
        }
        if (wasmModule.isInit) this.setAllTeethStep(stageup, stagelow);
      });
    });
  };
  /**
   * 设置wasm-stage当前index
   * @param stageupIndex
   * @param stagelowIndex
   */
  setAllTeethStep(stageupIndex, stagelowIndex) {
    if (wasmModule.stagingcontoler && wasmModule.stagingcontoler.ChangeStage) {
      wasmModule.stagingcontoler.ChangeStage(stageupIndex, 0);
      wasmModule.stagingcontoler.ChangeStage(stagelowIndex, 1);
      globalEvents.fire(GlobalEvents.ON_STAGESTEP_CHANGED, {
        upStep: stageupIndex,
        downStep: stagelowIndex,
      });
    }
  }
  setEndNodeIndex() {
    const upIndex = this.wasmStageData.jointUpKeypoints.length - 1;
    const downIndex = this.wasmStageData.jointLowerKeypoints.length - 1;
    console.log("upIndex-1>>", upIndex);
    console.log("downIndex-1>>", downIndex);
    if (upIndex >= downIndex) this.patientsSetStageData(0, upIndex);
    else this.patientsSetStageData(1, downIndex);
    // this.setStageStep(upIndex, downIndex);
  }
  VelocityModifyPaceValue(
    archType: number,
    movePace: number,
    rotatePace: number,
    startNum: number,
    endNum: number
  ) {
    if (!wasmModule.isInit) return;

    wasmModule.stagingcontoler.VelocityModifyPaceValue(
      archType,
      movePace,
      rotatePace,
      startNum,
      endNum
    );

    this.updateStages();
  }

  GetDefaultSpaceAndRotateValue(archType: number): number[] {
    if (!wasmModule.isInit) return [0.5, 0.5];
    const res =
      wasmModule.stagingcontoler.GetDefaultSpaceAndRotateValue(archType);
    return [res[1], res[1]];
  }
}
export const stagingManager = new StagingManager();
